import { RequestOptions } from "https"
import axios from 'axios'
/**
 * @property headers requestHeader
 */
interface RequestParams extends RequestOptions {
    headers?: {
        [key: string]: any
        /**
         * could be application/x-www-form-urlencodeed, application/json, etc
         */
        'content-type'?: string,
    },
    /**
     * default get, could be GET, POST, PUT, DELETE, etc
     */
    mode?: RequestMode,
    cache?: RequestCache,
    credentials?: RequestCredentials,
    redirect?: RequestRedirect,
    /**
     * body match content-type, if send JSON, only receive JSON.stringify(body)
     */
    body?: any,
    sendJSON?: boolean,
    [key: string]: any
}

export const env = 'pro'

export const commonFetch = (url: any, params: RequestParams = { sendJSON: false, cache: 'no-cache', method: 'get' }) => {

    // if (params && params.sendJSON) {
    //     params.body && typeof params.body === 'object' && (params.body = (params.body))
    // }
    let realUrl = url[env]
    const method = params.method?.toLowerCase()
    if (method === 'get') {
        if (params.body) {
            realUrl += '?' + new URLSearchParams(params.body).toString()
        }
    }else{
        params.data = params.body
    }
    delete params.body
    //  console.log(params)
    return (method === 'get'? axios.get(realUrl): axios.post(realUrl, {...params.data}))
}

export const getDownloadLink = (url: any, data: RequestParams = {}, success: Function = () => { }, fail: Function = () => { }) => {

    commonFetch(url, { ...data }).then(res => {
        success(res.data)
    }, error => {
        fail(error)
    })
}

export const getSignature = (url: any, data: any, success: Function = () => { }, fail: Function = () => { }) => {
    commonFetch(url, { ...data, method: 'get' }).then(res => {
        success(res.data)
    }, error => {
        fail(error)
    })
}
